export default class ActiveState {

  constructor() {
  }

  static get ACTIVE() { return "active" }
  static get INACTIVE() { return "inactive" }
  static get IDLE() { return "idle" }
}
